import { render, staticRenderFns } from "./CheckBoxFieldReadonly.vue?vue&type=template&id=3c9e92be&scoped=true"
import script from "./CheckBoxFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./CheckBoxFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9e92be",
  null
  
)

export default component.exports